/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Button from "../../extras/Button";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import Title from "../../extras/Title";
import { permissionError, warning } from "../../../util/Alert";
import {
  getAllServices,
  deleteService,
  serviceStatus,
} from "../../../redux/slice/serviceSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ServiceDialogue from "./ServiceDialogue";
import { ReactComponent as Delete } from "../../../assets/icon/delete.svg";
import { ReactComponent as Edit } from "../../../assets/icon/edit.svg";
import Searching from "../../extras/Searching";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";

const Service = () => {
  const dispatch = useDispatch();

  const { setting } = useSelector((state) => state.setting);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const { service, total } = useSelector((state) => state.service);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("ALL");
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const payload = {
    start: page,
    limit: rowsPerPage,
    search,
  };

  useEffect(() => {
    dispatch(getAllServices(payload));
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    setData(service);
  }, [service]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  function openImage(imageUrl) {
    // Open the image in a new tab or window
    window.open(imageUrl, "_blank");
  }

  const serviceTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row?.image}
            alt="image"
            // className="cursor-pointer"
            style={{ height: "50px", width: "50px"}}
            // onClick={() => openImage(row?.image)}
            height={`100%`}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.name}</span>
      ),
    },
    {
      Header: "Category",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.categoryname}</span>
      ),
    },

    {
      Header: "Duration",
      Cell: ({ row }) => <span>{row?.duration + " min"}</span>,
    },
    {
      Header: "Status",
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.status}
          onClick={() => handleStatus(row?._id)}
        />
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => dispatch(openDialog({ type: "service", data: row }))}
          >
             <IconEdit className="text-secondary" />
          </button>
          <button
            className="btn btn-sm"
            onClick={() => handleDelete(row._id)}
          >
           <IconTrash className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  const handleStatus = (id) => {
    if (!hasPermission) return permissionError();
    dispatch(serviceStatus(id));
  };

  const handleDelete = (id) => {
    if (!hasPermission) return permissionError();
    const data = warning("Delete");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        console.log("yes", yes);
        if (yes) {
          dispatch(deleteService(id));
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="userPage">
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5 className="main-title">Services</h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
              <Searching
                type={`server`}
                data={service}
                setData={setData}
                column={serviceTable}
                serverSearching={handleFilterData}
              />
              <Button
                bIcon={<IconPlus size={18} />}
                text="Add service"
                onClick={() => {
                  dispatch(openDialog({ type: "service" }));
                }}
              />
            </div>
          </div>
        </div>

        {/* <Title name="Services" /> */}
        <div className="row">
          <div className="col-3"></div>
          <div className="col-lg-5 col-md-7 col-8  ms-auto"></div>
        </div>
        <div>
          <Table
            data={data}
            mapData={serviceTable}
            serverPerPage={rowsPerPage}
            Page={page}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
        {dialogue && dialogueType === "service" && (
          <ServiceDialogue setData={setData} data={data} />
        )}
      </div>
    </div>
  );
};

export default Service;
